import PropTypes from 'prop-types'
import React, { useState } from 'react'
import AlertUi from './ui/AlertUi'
import CloseUi from './ui/CloseUi'

function Alert({ type = 'warning', children, onClose }) {
  const [isVisible, setVisible] = useState(true)

  const toggleShow = () => {
    if (onClose) {
      onClose()
    }
    setVisible(!isVisible)
  }

  return (
    isVisible && (
      <AlertUi type={type}>
        {children}
        <CloseUi onClick={toggleShow}>&times;</CloseUi>
      </AlertUi>
    )
  )
}

Alert.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  onClose: PropTypes.func,
}

export default Alert
